import React from 'react';
import { Box } from '@mui/material';

function PublicLayout({ children }) {
  return (
    <Box sx={{ minHeight: '100vh', width: '100vw', position: 'relative', overflow: 'hidden' }}>
      <Box
        component="img"
        src="/background.jpg"
        alt=""
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.5,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default PublicLayout;
